import { Directive, OnInit, inject } from '@angular/core'

import { FlxSelectComponent } from '@flowx/angular-ui-toolkit'
import { theme } from '@flowx/core-sdk'
import { ThemeComponent, getComponentStyles } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: 'flx-select[multi]',
  standalone: true,
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [{ provide: ComponentType, useValue: ThemeComponent.MultiSelect }],
})
export class FlxMultiSelectThemeDirective implements OnInit {
  selectComponent = inject(FlxSelectComponent)

  ngOnInit(): void {
    const optionClass = getComponentStyles(ThemeComponent.MultiSelectOption, theme())
    const chipsClass = getComponentStyles(ThemeComponent.Chips, theme())
    this.selectComponent.optionClass.set(`${optionClass} flx-themed`)
    this.selectComponent.chipsClass.set(`${chipsClass} flx-themed`)
  }
}
